import React from 'react';
import Api from '../util/Api';
import BookingUpsellService from './BookingUpsellService.jsx';
import {wpServicesToJsServices} from './bookingUtils';
import Storage from "../util/Storage";

const BookingUpsells = (props) => {
    const [upsells, setUpsells] = React.useState([]);
    React.useEffect(() => {
        let exclude = []
        if (props.services.length) {
            exclude = props.services.map(service => service.wpid).filter(onlyUnique);
        }
        Api.getUpsells(exclude, (response) => {
            const services = wpServicesToJsServices(response.data);
            setUpsells([...services]);
        });
    }, [props.services.length]);

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    function extraChangeHandler(checked, serviceId, extra) {
        const newUpsells = upsells.map(function(item) {
            if (item.id === serviceId) {
                item.extras.forEach(function(ex) {
                    if (ex.title === extra.title) {
                        ex.checked = checked;
                    }
                })
            }
            return item;
        });
        setUpsells(newUpsells)
    }

    if (!upsells.length) {
        return null;
    }

    return (
        <div className="booking-form__block">
            <h2 className="booking-form__title">You might also like</h2>
            <div className="flex flex-wrap">
                {upsells.map((item) => {
                    return (
                        <BookingUpsellService
                            key={item.id}
                            id={item.id}
                            title={item.title}
                            duration={item.duration}
                            description={item.description}
                            extras={item.extras}
                            price={item.price}
                            salesPrice={item.sales_price}
                            isOnSale={item.is_on_sale}
                            person={item.person || 1}
                            addItem={() => props.handleServiceAddClick(item)}
                            extraChangeHandler={extraChangeHandler}
                        />
                    );
                })}
            </div>
        </div>
    )
}

export default BookingUpsells;



// WEBPACK FOOTER //
// ./scripts/components/BookingUpsells.jsx